<app-employee-perf-grid
  (mySelected)="grid_onSelected($event)"
  (mySelectedRange)="date_onSelected($event)"></app-employee-perf-grid>

